import { render } from "./AnonymousAvatarContext.vue?vue&type=template&id=4d9cf000&scoped=true"
import script from "./AnonymousAvatarContext.vue?vue&type=script&lang=js"
export * from "./AnonymousAvatarContext.vue?vue&type=script&lang=js"

import "./AnonymousAvatarContext.vue?vue&type=style&index=0&id=4d9cf000&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9cf000"]])

export default __exports__